export enum FarmIdType {
    Npc = 1,
    Object,
    Quest,
    Instance,
    Group,
}
